import { Gallery } from "@singita/components"
import { showByTag } from "gatsby-singita-theme/src/common/utils"
import React from "react"
import AnimateInView from "../components/AnimateInView"
import BannerWrapper from "./BannerWrapper"

const LodgeBanners = ({ lodge }) => {
  const patternProps = {
    color: lodge.color,
    path: lodge.pattern?.pattern,
  }
  return lodge.banners && lodge.banners.length > 0 ? (
    <AnimateInView data-testid="lodge-banner" threshold={0.4}>
      <Gallery variant="banner" bg={lodge.color}>
        {showByTag(lodge.banners, "Singita").map(b => {
          const { headline, subtitle, image, content } = b
          return (
            <BannerWrapper
              key={b.id}
              className="BannerWrapper"
              content={{
                headline,
                subtitle,
                image,
                content,
              }}
              showLogo={false}
              showPattern={false}
              sx={{ ...b.meta, backgroundColor: lodge.color }}
              patternProps={patternProps}
            />
          )
        })}
      </Gallery>
    </AnimateInView>
  ) : null
}

export default LodgeBanners
